/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{defaultThematicColor as o}from"../../symbols/support/gfxUtils.js";const s=o;export{s as defaultThematicColor};
